// import React from 'react';
// // import cloud from "../../asset/image/mobilee.jpg"
// import "./banner.css"
// import Typewriter from "typewriter-effect";
// import { useSelector } from 'react-redux';

// const DashHome=(props)=>{
//     const { user } = useSelector(state => state.portfolio.auth)
//     console.log(user)
//     return (
//       <div className="banner">
      
//         <div className="content">
//           {/* <img src={cloud}></img> */}

//           <h1 className="heading">
//             <Typewriter
//               options={{
//                 autoStart: true,
//                 loop: true,
//                 delay: 40,
//                 strings: ["Welcome to ImportFolio.", "Design Your Portfolio."],
//               }}
//             />
//           </h1>


//           <p>Create, inspire, succeed with our portfolio builder.</p>

//           {user && props.id && <div className="content_a">
//             <a className="butt" href={`/portfolio/${props.id}`}>
//               View ImportFolio
//             </a>
//           </div>}

//           {user && !props.id &&
//             <div className="content_a">
//             <a className="butt" href={`/form`} >
//               Create ImportFolio
//             </a>
//           </div>
//           }

//           {!user &&
//             <div className="content_a">
//             <a className="butt" href="/login">
//               Create ImportFolio
//             </a>
//           </div>
//           } 

//         </div>
//       </div>
//     );
// }

// export default (DashHome);


import React from 'react';
import "./banner.css";
import Typewriter from "typewriter-effect";
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';


const DashHome = (props) => {
    const { user } = useSelector(state => state.portfolio.auth);
    console.log(user);

    return (
        <div className="banner">
            <div className="content">
                {/* <img src={cloud} alt="Banner Background"/> */}

                <h1 className="heading">
                    <Typewriter
                        options={{
                            autoStart: true,
                            loop: true,
                            delay: 40,
                            strings: ["Welcome to ImportFolio.", "Design Your Portfolio."],
                        }}
                    />
                </h1>

                <p>Create, inspire, succeed with our portfolio builder.</p>

                {user && props.id && (
                    <div className="content_a">
                        <Link className="butt" to={`/portfolio/${props.id}`}>
                            View ImportFolio
                        </Link>
                    </div>
                )}

                {user && !props.id && (
                    <div className="content_a">
                        <Link className="butt" to="/form">
                            Create ImportFolio
                        </Link>
                    </div>
                )}

                {!user && (
                    <div className="content_a">
                        <Link className="butt" to="/login">
                            Create ImportFolio
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}

export default DashHome;
